// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import Vue from "vue";
import api from '@/api';

var storage = window.localStorage;

export default {
  namespaced: true,
  state: {
    schedules: [],
    selectedSchedule: {},
  },
  mutations: {
    setSchedules(state, schedules) {
      let s = schedules || [];
      s = s.sort(function(a, b) {
        let as = a.StartDate;
        let bs = b.StartDate;
        return  as > bs ? 1 : as < bs ? -1 : 0;
      });
      state.schedules = s;
      state.selectedSchedule = s[0] || {};
    },
    setSelectedSchedule(state, id) {
      const sid = id || storage.getItem('sid');
      state.selectedSchedule = state.schedules.find(function(item) {
        return item.ID === sid;
      });
      storage.setItem('sid', sid)
    },
    updateSchedule(state, schedule) {
      let s = state.schedules.find(function(s) {
        return s.ID == schedule.ID;
      });

      let idx = state.schedules.indexOf(s);
      if (idx > -1) {
        Vue.set(state.schedules, idx, schedule);
        state.selectedSchedule = state.schedules[idx];
      } else {
        state.schedules.unshift(schedule);
        state.selectedSchedule = state.schedules[0] || {};
      }
    },
    spliceSchedule(state, schedule) {
      let idx = state.schedules.indexOf(schedule);
      if (idx > -1) {
        state.schedules.splice(idx, 1);
        state.selectedSchedule = state.schedules[0] || {};
      }
    },
  },
  actions: {
    async getSchedules({commit}, patientID) {
      const pid = patientID || storage.getItem('pid');
      let data = await api.getSchedulesForPatient(pid);
      commit('setSchedules', data.schedules || []);
    },
    async storeSchedule({commit}, schedule) {
      let s = await api.storeSchedule(schedule);
      if (s != null) {
        commit('updateSchedule', s);
        return s;
      }
      return null;
    },
    async removeSchedule({commit}, schedule) {
      let ok = await api.removeSchedule(schedule);
      if (ok) {
        commit('spliceSchedule', schedule);
      }
      return ok;
    },
    async assignCardToEAC({commit}, {scheduleid, code}) {
      let schedule = await api.assignCardToEAC(scheduleid, code);
      if (schedule) {
        commit('updateSchedule', schedule);
        return schedule;
      }
    },
    async assignCardToNFC({commit}, {scheduleid, code}) {
      let schedule = await api.assignCardToNFC(scheduleid, code);
      if (schedule) {
        commit('updateSchedule', schedule);
        return schedule;
      }
    },
    async clone({commit}, schedule) {
      let s = await api.cloneSchedule(schedule);
      if (s != null) {
        commit('updateSchedule', s);
        return s;
      }
      return null;
    },
    async getDeviceInfo(_, schedule) {
      return await api.getDeviceInfo(schedule.ID);
    }
  }
}
